import { toast } from "react-toastify";
import { call, delay, put, select } from "redux-saga/effects";
import axiosInstance from "../../utilities/axios-instance";
import WadoDevAxiosInstance from "../../utilities/wadodev-axios-instance";
import translator from "../../utilities/translator";

function* HttpClient(payload, authorization = true, warn = true) {
	const data = { ...payload };
	
	let methodName = data?.url?.replaceAll('/', '-');
	if (!navigator.onLine) {
		return {
			error: true,
			result: null,
			method: methodName
		};
	}

	const authToken = yield select(({ session: { token } }) => token);
	const userPreferences = yield select(({ session: { userPreferences } }) => userPreferences);
	const currentLanguage = yield select(({ session: { userPreferences } }) => userPreferences?.language);
	try {
		if(data.method === 'get'){
			window.imedAjaxLastCallInGet = new Date();
			//yield put(ShowLoader());
			//yield delay(10);
		}
		if(data.method !== 'get' && data.url !== 'Account/UpdateUserPreferences'){
			window.imedAjaxLastCallInPost = new Date();
			//yield put(ShowLoader());
			//yield delay(10);
		}
		if(data.token?.length > 0){
			data.headers = data.headers
				? { ...data.headers, Authorization: `Bearer ${data.token}` }
				: { Authorization: `Bearer ${data.token}` };
		}
		else
		if (authorization) {
			if (authToken) {
				data.headers = data.headers
					? { ...data.headers, Authorization: `Bearer ${authToken}` }
					: { Authorization: `Bearer ${authToken}` };
			} else {
				// return {
				// 	error: 'No Authentication Token',
				// 	result: null,
				// };
			}
		}

		let result;
		if (data.getFile) {
			({ data: result } = yield call(axiosInstance, {
				...data,
				headers: {
					...data.headers,
					"Content-Type": "application/json",
				},
				responseType: "blob",
			}));
		} else if (data.getPdf) {
				({ data: result } = yield call(axiosInstance, {
					...data,
					headers: {
						...data.headers,
						"Content-Type": "application/json",
						Accept: "application/pdf",
					},
					responseType: "blob",
				}));
		} else 
		if (data.useWadodev) {
			({ data: result } = yield call(WadoDevAxiosInstance, data));
		} else {
			({ data: result } = yield call(axiosInstance, data));
		}

		if(data.method !== 'get' && data.url !== 'Account/UpdateUserPreference'){
			window.imedAjaxLastCallOutPost = new Date();
			//yield put(HideLoader());
		}
		if(data.method === 'get'){
			window.imedAjaxLastCallOutGet = new Date();
			//yield put(HideLoader());
		}

		if(result.hasOwnProperty('status') && result.status !== 'Success' && warn){
			toast.warn(data.url.replace('/','-') + " - " + ((result?.status?.length > 0) ? translator(currentLanguage, userPreferences?.language, "api"+result.status) : "Unknow Error"));
		}
		return {
			error: null,
			result,
			method: data?.url?.replaceAll('/', ' ')
		};
	} catch (error) {

		if(data.method !== 'get' && data.url !== 'Account/UpdateUserPreference'){
			window.imedAjaxLastCallOutPost = new Date();
			//yield put(HideLoader());
		}
		if(data.method === 'get'){
			window.imedAjaxLastCallOutGet = new Date();
			//yield put(HideLoader());
		}

		const errorCode = error.code || error.response?.status;
		const requestLoginAgain = yield select(({ session: { requestLoginAgain } }) => requestLoginAgain);
		if(!requestLoginAgain){
				
			if (errorCode) {
				if (errorCode === "ECONNABORTED") {
					const message = "Please try later our servers are not responding.";

					toast.error(methodName + ': ' + message);
				} else if (errorCode === 401 || errorCode === 403) {
					document.dispatchEvent(
						new CustomEvent("medapp_session_unauthorized", {
						bubbles: true,
						detail: { text: "unauthorized" },
						})
					  );
					toast.error(methodName + ':Not authorized, please login');
				} else if (errorCode === 402) {
					// show nothing
				} else if (errorCode === 404 && data.getFile) {
					// show nothing
				} else if (errorCode === 400) {
					toast.error(methodName + ': ' + error.title);
				} else if (errorCode === 500) {
					toast.error(methodName + ': ' + error.title + ': ' + error.message);
				} else {
					toast.error(methodName + ': ' + error.message ?? "There has been a network error");
				}
			} else {
				toast.error(methodName + ': ' + error.message);
			}
		}

		return {
			error,
			result: null,
			method: data?.url?.replaceAll('/', ' ')
		};
	}
}

export default HttpClient;
